/** @jsxImportSource @emotion/react */
import React, { useMemo } from "react";
import { DemoGroupByConstants, DemoSelectionConstants } from "model/Model";
import { Selectable } from "Utilities";
import { css } from "@emotion/react";

const styles = {
  displayGroupSpace: css`
    margin-right: 5px;
  `,

  warning: css`
    color: #cc0000;
  `
};

export const ProgramPerformanceDemoDescription = ( { demoSelection, selectedCountries, measures, demoGroupBy, warningMessage }: { demoSelection: DemoSelectionConstants; demoGroupBy: DemoGroupByConstants; selectedCountries: Array<{ id: number; name: string; allDemosSelected: boolean; selectedDemos: Array<{ name: string; }>; }>; measures: Array<Selectable<{ name: string; }>>; warningMessage?: string; } ): JSX.Element => {
  const parts = useMemo( () => {
    const results: Array<JSX.Element> = [];

    switch ( demoSelection ) {
      case DemoSelectionConstants.allIndividualsAndAllCommercials: results.push( <div key={ "demoSelection" }>All individuals and all commercials demos</div> ); break;
      case DemoSelectionConstants.allIndividuals: results.push( <div key={ "demoSelection" }>All individuals demo</div> ); break;
      case DemoSelectionConstants.allCommercials: results.push( <div key={ "demoSelection" }>All commercials demo</div> ); break;
      case DemoSelectionConstants.selectedDemos:
        if ( selectedCountries.length === 0 ) {
          results.push( ( <div key={ "none" } ><span>{ "None" }</span></div> ) );
        } else {
          for ( const country of selectedCountries ) {
            const demoParts = [];

            if ( country.allDemosSelected ) {
              demoParts.push( "All demos" );
            } else {
              for ( const demo of country.selectedDemos ) {
                demoParts.push( demo.name );
              }
            }

            if ( demoParts.length === 0 ) {
              demoParts.push( "None" );
            }

            const demoTag = selectedCountries.length > 1 ? ( <span css={ styles.displayGroupSpace }>{ country.name }</span> ) : null;
            results.push( ( <div key={ country.id } >{ demoTag }<span>{ demoParts.join( ", " ) }</span></div> ) );
          }
        }
        break;
    }

    const measureParts: Array<string> = [];
    for ( const measure of measures ) {
      if ( measure.isSelected ) {
        measureParts.push( measure.name );
      }
    }

    const hasSelectedMeasures = measureParts.length > 0;
    if ( hasSelectedMeasures ) {
      const groupByTag = ( <span css={ styles.displayGroupSpace }><span>grouped by</span> <span>{ demoGroupBy }.</span></span> );
      const demoTag = ( <span ><span css={ styles.displayGroupSpace }>{ measureParts.join( ", " ) }</span>{ groupByTag }</span> );

      if ( hasSelectedMeasures ) {
        results.push( ( <div key={ "demoDisplay" }><span css={ styles.displayGroupSpace }>Display</span>{ demoTag }</div> ) );
      } else {
        results.push( ( <div key={ "demoDisplay" }>&nbsp;</div> ) );
      }
    }

    return results;
  }, [ demoGroupBy, demoSelection, measures, selectedCountries ] );

  if ( warningMessage ) return <span css={ styles.warning }>{ warningMessage }</span>;
  if ( parts.length > 0 ) return <>{ parts }</>;
  return <></>;
};
